module.exports = __webpack_public_path__ + "img/LOGO1.91e6e5f2.png";